<template>
  <a-modal v-model="visible" :title="`${form.id ? $t('编辑角色信息') : $t('新增角色信息')}`" :width="1000">
    <div slot="footer">
      <a-button @click="visible = false">{{ $t('取消') }}</a-button>
      <a-button :loading="loading" type="primary" @click="handleCommit">{{ $t('保存') }}</a-button>
    </div>
    <a-form-model ref="form" :model="form" :rules="rules" :labelCol="{ span: 4 }" :wrapperCol="{ span: 18 }">
      <a-row>
        <a-col :span="24">
          <a-form-model-item :label="$t('角色名称')" prop="name">
            <a-input v-model="form.name" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('角色标识')" prop="key">
            <a-input v-model="form.key" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('角色类型')" prop="type">
            <a-select v-model="form.type" :options="roleTypeOptions" />
          </a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item :label="$t('所属应用')" prop="appId">
            <a-select v-model="form.appId" :options="appOptions" :disabled="form.id != null" allowClear />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>
<script>
import { saveRole } from '@/api/system/role'
import { getAppListForCurrentUser } from '@/api/app/app'
import { roleTypeOptions } from '@/constants/SystemConstatns'

export default {
  data() {
    return {
      roleTypeOptions,
      visible: false,
      appOptions: [],
      form: {},
      loading: false,
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.user
    },
    rules() {
      const result = {
        name: [{ required: true, message: this.$t('请输入') }],
        key: [{ required: true, message: this.$t('请输入') }],
      }
      return result
    }
  },
  created() {
  },
  methods: {
    show(data) {
      this.form = { ...data }
      this.visible = true
      this.loadOptions()
    },
    loadOptions() {
      getAppListForCurrentUser().then(res => {
        this.appOptions = res.data?.map(e => ({ label: e.name, value: e.id })) ?? []
      })
    },
    handleCommit() {
      this.$refs.form.validate((success) => {
        if (!success) {
          return
        }
        this.loading = true
        const commitData = {
          ...this.form,
        }
        saveRole(commitData).then(res => {
          if (res.code === 0) {
            this.$message.success(this.$t('保存成功'))
            this.$emit('ok', this.form)
            this.visible = false
          } else {
            this.$message.error(res.message || this.$t('保存失败'))
          }
        }).catch(err => {
          this.$message.error(this.$t('保存失败'))
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>